import { IApiClient } from "./ApiClient";


export interface ICloudinaryService {
    uploadImage(file: Blob): Promise<CloudinaryResponse | undefined>;
}

export interface CloudinaryResponse {
    secure_url: string
}

export default class CloudinaryService implements ICloudinaryService {
    apiBase: string;
    apiClient: IApiClient;

    constructor(apiClient: IApiClient) {
        this.apiBase = `https://api.cloudinary.com/v1_1/dm1881/upload`;
        this.apiClient = apiClient;
    }
    async uploadImage(file: File): Promise<CloudinaryResponse | undefined> {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'min_bedrift_preview');
        formData.append('cloud_name', 'dm1881');


        try {
            const response = await this.apiClient.post<FormData, any>(
                this.apiBase,
                formData,
                {
                    skipAuth: true,
                    headers: {
                    }
                }
            );

            return response
        } catch (error) {
            console.error('Upload failed:', error);
            return undefined;
        }
    }
}
